import {
  AHIcon,
  AHText,
  AHTextFonts,
  TouchableBox,
  TouchableBoxProps,
} from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";

export function KPIAddSubSectionButton(props: TouchableBoxProps) {
  return (
    <TouchableBox
      {...props}
      style={[{ flexDirection: "row", alignItems: "center" }, props.style]}
    >
      <AHIcon type="add" color="primary" />
      <AHText
        color="primary"
        type="title-small"
        spaceLeft="small"
        font={AHTextFonts.REGULAR}
      >
        <FormattedMessage
          defaultMessage="Add measurement area"
          description="KPIAddSubSectionButton title"
        />
      </AHText>
    </TouchableBox>
  );
}
